import { requireUid } from './auth';
import { paths } from './paths';
import { readOptionalValue, writeValue } from './rtdb';

/**
 * La formation d'un membre dans une ecole.
 *
 * Elle vit par ecole (`parcours/{serveur}/{uid}`) et non dans la fiche du
 * membre : la fiche se lit depuis tous les serveurs, alors que la
 * formation ne regarde que ceux de son ecole. Elle range l'annuaire en
 * blocs. Le CV qui l'accompagnait a ete retire le 7 octobre 2026.
 */

/** Ce qui est range pour un membre. */
export interface ParcoursRecord {
  majAt: number;
  formation?: string;
}

/** Les formations de tous les membres d'une ecole, d'une lecture. */
export async function lireLesParcours(serverId: string): Promise<Record<string, ParcoursRecord>> {
  return (await readOptionalValue<Record<string, ParcoursRecord>>(paths.parcours(serverId))) ?? {};
}

/** Dire sa formation, ou ne plus la dire (`null`) : on quitte alors tous les blocs. */
export async function enregistrerMaFormation(serverId: string, formation: string | null): Promise<void> {
  await writeValue(
    paths.parcoursDe(serverId, requireUid()),
    formation ? { majAt: Date.now(), formation } : null,
  );
}
